
import React, { useMemo } from "react";

import HomeHeader from "./HomeHeader.jsx";
import ProjectSearch from "./ProjectSearch.jsx";
import ProjectCard from "./ProjectCard.jsx";

const getProjectId = (project) => {
  if (!project) return "";

  return String(
    project.projectId ??
      project.projectID ??
      project.project_id ??
      project.projectCode ??
      project.code ??
      project._id ??
      "",
  ).trim();
};

const ProjectSelectionView = ({
  userDetails,
  assignedProjects = [],
  filteredProjects = [],
  selectedProject,
  searchTerm,
  onSearchChange,
  onProjectSelect,
}) => {
  const hasProjects = assignedProjects.length > 0;
  const hasFilteredProjects = filteredProjects.length > 0;

  const sortedProjects = useMemo(() => {
    return [...filteredProjects].sort((projectA, projectB) => {
      const projectIdA = getProjectId(projectA);
      const projectIdB = getProjectId(projectB);

      return projectIdA.localeCompare(projectIdB, undefined, {
        numeric: true,
        sensitivity: "base",
      });
    });
  }, [filteredProjects]);

  return (
    <>
      <HomeHeader userDetails={userDetails} />

      <div className="project-section">
        <div className="project-section-header">
          <h2 className="section-title">Your Projects</h2>

          {hasProjects && (
            <ProjectSearch
              value={searchTerm}
              onChange={onSearchChange}
            />
          )}
        </div>

        {!hasProjects ? (
          <div className="no-project-message">
            No projects are currently assigned to your account.
            <br />
            Please contact your administrator.
          </div>
        ) : !hasFilteredProjects ? (
          <div className="no-project-message">
            No projects match your search.
          </div>
        ) : (
          <div className="project-cards-container">
            <ProjectCard
              isPortfolio
              isActive={selectedProject === ""}
              onClick={() => onProjectSelect("")}
            />

            {sortedProjects.map((project) => {
              const projectKey = project._id || getProjectId(project);

              return (
                <ProjectCard
                  key={projectKey}
                  project={project}
                  isActive={selectedProject === project._id}
                  onClick={() => onProjectSelect(project._id)}
                />
              );
            })}
          </div>
        )}
      </div>
    </>
  );
};

export default ProjectSelectionView;
